module.exports = __webpack_public_path__ + "assets/img/Structure_img_mask.b33ad073.png";